import { render, staticRenderFns } from "./GlobalNewsList.vue?vue&type=template&id=ceeb5570&scoped=true"
import script from "./GlobalNewsList.vue?vue&type=script&lang=js"
export * from "./GlobalNewsList.vue?vue&type=script&lang=js"
import style0 from "./GlobalNewsList.vue?vue&type=style&index=0&id=ceeb5570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceeb5570",
  null
  
)

export default component.exports